import React, { useState, useEffect } from "react";
import "./ErrorHandler.css";

export default function ErrorHandler(props) {
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleErrors = (err) => {
      setError(err);
    };
    window.addEventListener("error", handleErrors);
    return () => {
      window.removeEventListener("error", handleErrors);
    };
  }, []);

  const onTryAgain = () => {
    window.location.reload()
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error-block">
            <h1>Something went wrong: {error.message}</h1>
            <button onClick={onTryAgain}>Try Again</button>
        </div>
      </div>
    );
  }

  return props.children;
}
